import React from 'react'
import { useTranslation } from 'react-i18next'
import { goToHomePage } from '../../helpers/Utils'
import { Label } from '../ui/label'
import { Card, CardContent } from '../ui/card'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../ui/select'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}

export default function ViewRequestActiveStep2 ({
  formData,
  handleChange,
  onStep2CTA,
  dmsList,
  activeStep,
  setActiveStep
}) {
  const { t } = useTranslation(['viewRequest'])

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <CardContent
          style={{
            height: 'auto',
            minWidth: '717px'
          }}
          className='login-right'
        >
          <span
            style={{
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '16px',
              color: '#60646C',
              backgroundColor: '#E8E8EC',
              borderRadius: '6px',
              padding: '2px 4px'
            }}
          >
            {t('step')} 1 {t('of')} 2
          </span>
          <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8 gp-mt8'>
            {t('yourMasterData')}
          </h2>
          <p className='subheading'>
            {t('correctOrCompleteMissing')}
          </p>

          <div className='form-group gp-mb16'>
            <Label htmlFor='workshopAccountName' className='gp-mb8'>
              {t('nameOfWorkshop')}
            </Label>
            <Input
              value={formData?.workshopAccountName || ''}
              disableUnderline
              disabled
              style={{
                width: '100%',
                fontSize: '12px'
              }}
              placeholder='Autoservice Max Mustermann'
              name='workshopAccountName'
              id='workshopAccountName'
            />
          </div>

          <div className='form-group gp-mb16'>
            <Label htmlFor='dmsId' className='gp-mb8'>
              {t('dmsSwInUse')}
            </Label>
            <Select
              onValueChange={(data) =>
                handleChange({
                  target: { name: 'dmsId', value: data }
                })}
              defaultValue={formData.dmsId || ''}
            >
              <SelectTrigger>
                <SelectValue placeholder={t('currentDMSPlaceholder')} />
              </SelectTrigger>
              <SelectContent>
                {dmsList.map((el) => {
                  return (
                    <SelectItem key={el.id} value={el.id}>
                      {el.name}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </Select>
            <span style={errorStyle}>{formData.dmsIdError || ''}</span>
          </div>

          <div className='form-group gp-mb16'>
            <Label htmlFor='dmsAccountId' className='gp-mb8'>
              {t('customerDmsReferenceNo')}
            </Label>
            <Input
              name='dmsAccountId'
              value={formData.dmsAccountId || ''}
              onChange={handleChange}
              placeholder={t('DMSCustomerIdPlaceholder')}
              id='dmsAccountId'
            />
            <span style={errorStyle}>{formData.dmsAccountIdError || ''}</span>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '16px'
            }}
          >
            <Button
              style={{
                width: '49%',
                border: '1px solid #00002F29',
                backgroundColor: 'transparent',
                color: '#1C2024'
              }}
              className='login-button'
              onClick={() => {
                setActiveStep(activeStep + 1)
              }}
            >
              {t('skipAndSetupLater')}
            </Button>
            <Button
              style={{
                width: '49%'
              }}
              className='login-button bg-[#6926D9]'
              onClick={onStep2CTA}
            >
              {t('next')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
